import "./Perks.scss";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import useIsMobile from '../../hooks/ScreenWidth';

const Perks = ({ cardData = [] }) => {
  const isMobile = useIsMobile();

  const breakpointsConfig = {
    575: { slidesPerView: 2.5 },
    390: { slidesPerView: 2.4 },
    320: { slidesPerView: 2.2 },
  };

  return (
    <section className={`section-padding-lg solution-features`}>
      <div className="container-lg">
        <div className="solution-features__content">
          {isMobile ? (
            <Swiper spaceBetween={18} speed={1000} breakpoints={breakpointsConfig}>
              {cardData.map((card) => (
                <SwiperSlide key={card.id}>
                  <div className="solution-features__item">
                    <figure>
                      <img src={card.image} alt={card.imageAlt} />
                    </figure>
                    <div className="solution-features__item-header">
                      <h2 dangerouslySetInnerHTML={{ __html: card.text }} />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="solution-features__grid">
              {cardData.map((card) => (
                <div key={card.id} className="solution-features__item">
                  <figure>
                    <img src={card.image} alt={card.imageAlt} />
                  </figure>
                  <div className="solution-features__item-header">
                    <h2 dangerouslySetInnerHTML={{ __html: card.text }} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Perks;
